import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min'

const mapStateToProps = ({ usuarioReducer }) => ({
  usuarioMenuKeys: usuarioReducer?.usuarioMenuKeys,
  usuarioPerfil: usuarioReducer?.usuarioPerfil,
})

const ProtectedRoute = ({ children, keyMenu, usuarioMenuKeys, usuarioPerfil }) => {
  if (keyMenu && keyMenu !== '') {
    if (usuarioPerfil?.data) {
      if (!usuarioPerfil?.data?.verComoConocio && !usuarioPerfil?.data?.permitidoIp) {
        return <Redirect to="/auth/403" />
      }
    }

    if (usuarioMenuKeys && usuarioMenuKeys?.data) {
      // Extraer las keys autorizadas del usuario
      const menuKeys = usuarioMenuKeys?.data?.menuKeys
      // Localizar si la keyMenu está en la lista de keys autorizadas para el usuario
      const result = menuKeys.includes(keyMenu)
      if (!result) {
        return <Redirect to="/auth/401" />
      }
    }
  }

  return children
}

export default connect(mapStateToProps, null)(ProtectedRoute)
